'use strict';

var react = require('react');
var debounce = require('lodash.debounce');
var useLatestRef = require('../useLatestRef/useLatestRef.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var debounce__default = /*#__PURE__*/_interopDefaultCompat(debounce);

/**
 * Hook version of lodash debounce fn to make it react friendly.
 */ function useDebounce({ callback, delay, options }) {
    const callbackRef = useLatestRef.useLatestRef(callback);
    const optionsRef = useLatestRef.useLatestRef(options);
    const debounceFunc = react.useMemo(()=>debounce__default.default((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        callbackRef,
        delay,
        optionsRef
    ]);
    // when component unmounts, debounced function could still be running, so cleanup
    react.useEffect(()=>{
        return ()=>{
            debounceFunc.cancel();
        };
    }, [
        debounceFunc
    ]);
    return debounceFunc;
}

exports.useDebounce = useDebounce;
//# sourceMappingURL=useDebounce.js.map
